const childRoutes = (prop) => [
    {
        path: 'accommodation-type',
        name: prop + '.accommodation_type',
        meta: { auth: true },
        component: () => import('../pages/accommodation-type/List.vue')
    },
    {
        path: 'questionnaire-type',
        name: prop + '.questionnaire_type',
        meta: { auth: true },
        component: () => import('../pages/questionnaire-type/List.vue')
    },
    {
        path: 'organization-type',
        name: prop + '.organization_type',
        meta: { auth: true },
        component: () => import('../pages/organization-type/List.vue')
    },
    {
        path: 'guest-house',
        name: prop + '.guest_house',
        meta: { auth: true },
        component: () => import('../pages/guest-house/List.vue')
    },
    {
        path: 'training-name',
        name: prop + '.training-name',
        meta: { auth: true },
        component: () => import('../pages/training-name/List.vue')
    },
    {
        path: 'grade',
        name: prop + '.grade',
        meta: { auth: true },
        component: () => import('../pages/grade/List.vue')
    },
    {
        path: 'designation',
        name: prop + '.designation',
        meta: { auth: true },
        component: () => import('../pages/designation/List.vue')
    },
    {
        path: 'committee-designation',
        name: prop + '.committee_designation',
        meta: { auth: true },
        component: () => import('../pages/committee-designation/List.vue')
    },
    {
        path: 'batch',
        name: prop + '.batch',
        meta: { auth: true },
        component: () => import('../pages/batch/List.vue')
    },
    {
        path: 'document-type',
        name: prop + '.document_type',
        meta: { auth: true },
        component: () => import('../pages/document-type/List.vue')
    },
    {
        path: 'faq-setup',
        name: prop + '.faq_setup',
        meta: { auth: true },
        component: () => import('../pages/faq-setup/List.vue')
    },
    {
        path: 'accommodation-setup',
        name: prop + '.accommodation_setup',
        meta: { auth: true },
        component: () => import('../pages/accommodation-setup/List.vue')
    },
    {
        path: 'registration-for',
        name: prop + '.registration_for',
        meta: { auth: true },
        component: () => import('../pages/registration-for/List.vue')
    },
    {
        path: 'questionnaire-setup',
        name: prop + '.questionnaire_setup',
        meta: { auth: true },
        component: () => import('../pages/questionnaire-setup/List.vue')
    },
    {
        path: 'report-heading-list',
        name: prop + '.report_heading_list',
        meta: { auth: true },
        component: () => import('../pages/report-heading/List.vue')
    },
    {
        path: 'education-qualification',
        name: prop + '.education_qualification',
        meta: { auth: true },
        component: () => import('../pages/education-qualification/List.vue')
    },
    {
        path: 'module-name',
        name: prop + '.module_name',
        meta: { auth: true },
        component: () => import('../pages/module-name/List.vue')
    },
    {
        path: 'venue-info',
        name: prop + '.venue_info',
        meta: { auth: true },
        component: () => import('../pages/venue-info/List.vue')
    },
    {
        path: 'committee-name',
        name: prop + '.committee_name',
        meta: { auth: true },
        component: () => import('../pages/committee-name/List.vue')
    },
    {
        path: 'food-package',
        name: prop + '.food_package',
        meta: { auth: true },
        component: () => import('../pages/food-package/List.vue')
    },
    {
        path: 'room-type',
        name: prop + '.room_type',
        meta: { auth: true },
        component: () => import('../pages/room-type/List.vue')
    },
    {
        path: 'evaluation-subject',
        name: prop + '.evaluation_subject',
        meta: { auth: true },
        component: () => import('../pages/evaluation-subject/List.vue')
    },
    {
      path: 'received-notifications',
      name: prop + '.received_notifications',
      meta: { auth: true },
      component: () => import('../pages/received-notifications/List.vue')
    }
]

const routes = [{
    path: '/training-e-learning-service/configuration',
    name: 'training_e_learning_service.configuration',
    component: () => import('@/layouts/TrainingElearningLayout.vue'),
    meta: { auth: true },
    children: childRoutes('training_e_learning_service.configuration')
}]

export default routes
